var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A4A7AE",
  d: "M20.692 12.287a.8.8 0 0 1-.162.244l-4 4a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.061l2.72-2.72H4a.75.75 0 0 1 0-1.5h14.189l-2.72-2.72a.75.75 0 0 1 1.061-1.061l4 4a.75.75 0 0 1 .162.818"
})));
export default SvgArrowRightSmall;